import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { IconButton, Popover, Typography, alpha } from "@mui/material";
import { useId } from "react";
import { usePopover } from "../../../utils/hooks/use-popover";

import type { SxProps, Theme } from "@mui/material";
import type { FC, ReactNode } from "react";

export const CeHelpButton: FC<{
  content: ReactNode;
  buttonSx?: SxProps<Theme>;
  variant?: "tooltip" | "popover";
}> = ({ content, variant = "popover" }) => {
  const [anchorRef, popover] = usePopover<HTMLButtonElement>();
  const id = useId();

  return (
    <>
      <IconButton
        data-analytics-id="ce-help-button"
        onMouseEnter={popover.handleOpen}
        onMouseLeave={popover.handleClose}
        ref={anchorRef}
        aria-owns={id}
        aria-haspopup="true"
      >
        <InfoOutlined fontSize="small" color="primary" />
      </IconButton>
      <Popover
        id={id}
        open={popover.open}
        // oxlint-disable-next-line react/refs -- MUI anchorEl needs the DOM node; the popover only opens after the anchor has mounted
        anchorEl={anchorRef.current}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{
          paper: {
            onMouseEnter: popover.handleOpen,
            onMouseLeave: popover.handleClose,
            sx: (theme) => ({
              pointerEvents: "auto",
              maxHeight: "75vh",
              overflow: "scroll",
              ...(variant === "tooltip" && {
                backgroundColor: alpha(theme.palette.grey[700], 0.92),
                color: theme.palette.common.white,
                borderWidth: 0,
              }),
            }),
          },
        }}
        sx={{
          pointerEvents: "none",
        }}
      >
        {typeof content === "string" ? (
          <Typography variant="body2" sx={{ p: 2, maxWidth: "30em" }}>
            {content}
          </Typography>
        ) : (
          content
        )}
      </Popover>
    </>
  );
};
